import { t } from 'app/i18l'
import { useRoutingContext } from 'app/routing_context'
import { useCalendarSyncContext } from 'calendar_sync/context'
import { SettingsScreenProps } from 'home/stack/types'
import React, { useLayoutEffect, useMemo } from 'react'
import { usePerformSettingAction } from 'settings/queries/perform_action'
import { useSettings } from 'settings/queries/settings'

import { SettingsSource } from 'settings/queries/shared/types'
import { SettingsView } from 'settings/screens/settings/views/settings'
import { onBooleanSettingChanged, onPressSetting } from 'settings/utils'
import { StatusBoundary } from 'shared/components/status_boundary'
import { showHeaderTitle } from 'shared/header/header_title'
import { useRecentStoresContext } from 'stores/context'

export function SettingsScreen({ navigation, route }: SettingsScreenProps) {
  const { handleNavigation } = useRoutingContext()
  const { homeStoreId } = useRecentStoresContext()
  const query = useSettings(route.params.type, homeStoreId)

  const getSettingsTitle = (type: SettingsSource['type']) => {
    if (type === 'store') {
      return 'editMyProfile'
    } else {
      return 'settings'
    }
  }
  useLayoutEffect(
    () =>
      showHeaderTitle(
        navigation,
        route.params.type && t(getSettingsTitle(route.params.type))
      ),
    [navigation, route.params.type]
  )

  const { calendarSyncSettingValue, setCalendarSyncSettingValue } =
    useCalendarSyncContext()

  const settingsSource: SettingsSource = useMemo(
    () => ({
      type: route.params.type,
      storeId: homeStoreId,
    }),
    [homeStoreId, route.params.type]
  )

  const mutation = usePerformSettingAction(settingsSource)

  return (
    <StatusBoundary isLoading={query.isLoading} error={query.error}>
      <SettingsView
        settings={query.data?.settings}
        onPressSetting={setting =>
          onPressSetting(setting, handleNavigation, settingsSource)
        }
        onBooleanSettingChanged={(setting, value) =>
          onBooleanSettingChanged(setting, value, mutation)
        }
        {...(route.params.type === 'user'
          ? { calendarSyncSettingValue, setCalendarSyncSettingValue }
          : {})}
      />
    </StatusBoundary>
  )
}
